import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import DToastHeader from './components/DToastHeader';
import DToastBody from './components/DToastBody';
function DToast({ children, className, style, dataAttributes, }) {
    return (_jsx("div", Object.assign({ className: classNames('toast', className), role: "alert", "aria-live": "assertive", "aria-atomic": "true", style: style }, dataAttributes, { children: children })));
}
export default Object.assign(DToast, {
    Header: DToastHeader,
    Body: DToastBody,
});
//# sourceMappingURL=DToast.js.map